<template>
  <v-footer
    class="bg-footercolor text-center d-flex flex-column"
  >
    <div>

      <!-- <v-btn
                class="mr-1 my-1"
                variant="flat"
                color="vs"
                href="https://t.me/islingsup" target="_blank">
                <span class="text-h5">
                L.'s Telegram
                </span>                 
                <svg-icon type="mdi" :path="mdiSend"/>
                <v-tooltip
                  activator="parent"
                  location="bottom"
                >Open in TG app </v-tooltip>
              </v-btn> -->
              <v-btn
                class="my-1"
                variant="flat"
                color="regular"
                v-copy="'islingsup@gmail.com'"
                @click="clicktooltipMessage"
                >
                <span class="text-h5">
                  islingsup@gmail.com 
                </span> <svg-icon type="mdi" :path="mdiEmail"/>
                <v-tooltip
                  activator="parent"
                  location="bottom"
                >{{clicktooltip}}</v-tooltip>
              </v-btn>

              <v-btn
                v-if="allCookies.username"
                class="my-1 ml-2"
                variant="outlined"
                color="vs"
                >
                <span class="text-h5">
                  You're logged in as {{ allCookies.username }}
                </span>
              </v-btn>


    </div>

    <!--div>
      it's just tool
    </div-->

   <v-btn variant="text" @click="$router.push('/')">
      {{ new Date().getFullYear() }} — <strong><span class="text-regular">L</span><span class="text-vs px-0">.</span></strong>
   </v-btn>
  </v-footer>
</template>
<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiSend, mdiEmail } from '@mdi/js';
  export default {
    name: 'BaseFooter',
    components: {
      SvgIcon,
  },

  data(){ 
        return {
          mdiSend:mdiSend,
          mdiEmail:mdiEmail,
      clicktooltip: 'Click to copy',
      allCookies: '',
        }
    },


    mounted(){
        let cookieUserData = (decodeURIComponent($store.state.cookies).match('(^|; )' + decodeURIComponent('userData') + '=([^;]+)') || []).pop() || null;
        if (cookieUserData !== null) { 
          this.allCookies = JSON.parse(cookieUserData);
        }
        else {
          this.allCookies = '';
        }
    },


    methods: {
        clicktooltipMessage(){
          if (this.clicktooltip =='Click to copy') {
          this.clicktooltip = 'Copied';
          }
          else {
            this.clicktooltip = 'Click to copy';
          }
          setTimeout(() => {
        this.clicktooltip = 'Click to copy';
      }, 10000);

        },

    },


  }
</script>